import { render, staticRenderFns } from "./MessageType.vue?vue&type=template&id=073d47b8&scoped=true"
import script from "./MessageType.vue?vue&type=script&lang=ts"
export * from "./MessageType.vue?vue&type=script&lang=ts"
import style0 from "./MessageType.vue?vue&type=style&index=0&id=073d47b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d47b8",
  null
  
)

export default component.exports